import React from "react";
import { newsecondaryColor } from "@app/styles";
type Props = {
  style?: Object
};

export default function LoaderIcon({ style }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="81px"
      height="81px"
      style={style}
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
    >
      <circle
        cx="50"
        cy="50"
        fill="none"
        stroke={newsecondaryColor}
        strokeWidth="5"
        r="35"
        strokeDasharray="164.93361431346415 56.97787143782138"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          repeatCount="indefinite"
          dur="0.9090909090909091s"
          values="0 50 50;360 50 50"
          keyTimes="0;1"
        ></animateTransform>
      </circle>
    </svg>
  );
}
